<div class="comments" tabindex="-1" aria-label="Comments">
  @if (showForm) {
    <form class="comments__form" (ngSubmit)="submit()">
      <ut-avatar-badges class="comments__avatar" user="me" aria-hidden="true"></ut-avatar-badges>
      <div class="comments__editor">
        <ut-editor [(value)]="newComment.content" text-area-label="Write your comment here"></ut-editor>
      </div>
      <!-- aria-disabled, not disabled, so focus stays on Post while it sends. -->
      <button type="submit" class="ut-btn ut-btn--sm comments__submit" [attr.aria-disabled]="posting()">Post</button>
    </form>
  }

  <ul class="comments__list">
    @for (comment of recentComments.concat(olderComments); track comment.id) {
      <li class="comments__comment">
        <ut-avatar-badges class="comments__avatar" [user]="comment.user" aria-hidden="true"></ut-avatar-badges>
        <div class="comments__comment-body">
          <div class="comments__comment-header">
            <span class="comments__comment-author">{{ comment.user.name }}</span>
            <span class="comments__comment-date">{{ comment.published_at | relativeDate }}</span>
          </div>
          <div class="comments__comment-content" [innerHTML]="comment.html"></div>
        </div>
      </li>
    }
  </ul>

  <p class="sr-only" role="status">{{ announcement() }}</p>

  @if (commentFeed.isLoading) {
    <ut-loading-dots></ut-loading-dots>
  } @else if (canLoadMore) {
    <button type="button" class="comments__more" (click)="loadMore()">Show more comments</button>
  }
</div>
